module.exports = __webpack_public_path__ + "static/websites-code-block-144b2ae5d84ad3dce701e5bc53858254.svg";